/**
 * Created by Administrator on 2019/1/31.
 */
import Vue from 'vue';
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '7f79466b4993b4d4ed4ee08ecc262e38',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.4'
});



// WEBPACK FOOTER //
// ./plugins/vue-map.js